interface ISettings {
  title: string
  showSettings: boolean
  showTagsView: boolean
  showSidebarLogo: boolean
  fixedHeader: boolean
  errorLog: string[]
  sidebarTextTheme: boolean
  devServerPort: number
  mockServerPort: number
}

const settings: ISettings = {
  title: '食促会商家端',
  showSettings: false, // 是否显示设置
  showTagsView: true,
  fixedHeader: true,
  showSidebarLogo: false,
  errorLog: ['production'],
  sidebarTextTheme: true,
  devServerPort: 9527,
  mockServerPort: 9528
}

export default settings
